import React from 'react';
import SuperAdminHeader from './SuperAdminHeader';
import AppContentView from '../../AppContentView';
import AppFooter from '../components/AppFooter';
import clsx from 'clsx';
import { FooterType } from '@nxsys/constants/AppEnums';
import { useLayoutContext } from '@nxsys/context/AppContextProvider/LayoutContextProvider';
import { StyledAppLayout, StyledMainScrollbar } from '../Default/index.styled';
import { StyledSuperAdminMain } from './index.styled';

type Props = {
  routes: React.ReactElement | null;
};

const SuperAdminLayout: React.FC<Props> = ({ routes }) => {
  const { footer, footerType } = useLayoutContext();

  return (
    <StyledAppLayout
      className={clsx({
        appMainFooter: footer && footerType === FooterType.FLUID,
        appMainFixedFooter: footer && footerType === FooterType.FIXED,
      })}
    >
      <StyledSuperAdminMain className="app-layout-main">
        <SuperAdminHeader />
        <StyledMainScrollbar>
          <AppContentView routes={routes} />
          <AppFooter />
        </StyledMainScrollbar>
      </StyledSuperAdminMain>
    </StyledAppLayout>
  );
};

export default React.memo(SuperAdminLayout);
